module.exports = __webpack_public_path__ + "img/warn.ffa33a82.png";